const WITH_LOGS = false;

class Flip {

  constructor(d) {
    if (WITH_LOGS === true) {
      console.log("[FLIP] New FLIP created!");
    }
    this.duration = d ? 500 : 500;
    this.positions = {}
  }

  read(elements) {
    if (WITH_LOGS === true) {
      console.log("[FLIP] [read]");
    }
    elements.forEach(element => {
      const id = element.getAttribute('id');
      if (WITH_LOGS === true) {
        console.log("[FLIP] [read] id = ", id);
      }
      // Verify DOM Rect before saving it
      const elementDOMRect = element.getBoundingClientRect();
      if ((elementDOMRect.x !== 0) || (elementDOMRect.y !== 0) || (elementDOMRect.width !== 0) || (elementDOMRect.height !== 0)) {
        this.positions[id] = elementDOMRect;
      }
    })
    if (WITH_LOGS === true) {
      console.log("[FLIP] [read] saved positions = ", this.positions);
    }
  }

  play(elements) {
    if (WITH_LOGS === true) {
      console.log("[FLIP] [play] elements.length = ", elements.length );
    }
    elements.forEach(element => {
      const id = element.getAttribute('id');
      if (WITH_LOGS === true) {
        console.log("[FLIP] [play] id = ", id);
      }
      const newPosition = element.getBoundingClientRect();
      // console.log("[FLIP] [play] this.positions = ", this.positions );
      const oldPosition = this.positions[id];

      if ((oldPosition !== undefined) && (newPosition.width !== 0) && (newPosition.height !== 0)) {

        if (WITH_LOGS === true) {
          console.log("[FLIP] [play] from ", oldPosition , " to " , newPosition);
        }

        const deltaX = oldPosition.x - newPosition.x;
        const deltaY = oldPosition.y - newPosition.y;
        const deltaW = oldPosition.width / newPosition.width;
        const deltaH = oldPosition.height / newPosition.height;

        const transform = `translate(${deltaX}px, ${deltaY}px) scale(${deltaW}, ${deltaH})`;

        element.animate([{
          transform: transform
        }, {
          transform: 'none'
        }], {
          duration: this.duration,
          easing: 'ease-in-out',
          // fill: 'both'
        });

        // element.style.transform = transform;
        if (WITH_LOGS === true) {
          console.log("[FLIP] [play] transform ", transform);
        }

      } else {
        // oldPosition === undefined

        element.style.visibility = 'hidden';
        element.style.opacity = 0;

        setTimeout(() => {
          element.style.transition = 'visibility 0.3s linear, opacity 0.3s linear';
          element.style.visibility = 'visible';
          element.style.opacity = 1;
        }, this.duration);

      }

    })
  }
}

export default Flip